import { useState } from 'react';

import { AddAccount } from '@/features/account-actions';

import { CurrencyAccountItem } from '@/entities/currency-account';
import { useAccountsHook } from '@/entities/currency-account/model/hooks';
import { useSendAccountStore } from '@/entities/currency-account/model/store';

import { Button, ScrollArea, Typography } from '@/shared/ui';

export const AddMoneyAccountContent: React.FC<{
  onSelect: () => void;
  onClose: () => void;
}> = ({ onSelect, onClose }) => {
  const { data, isLoading } = useAccountsHook();
  const account = useSendAccountStore((state) => state.account);
  const setAccount = useSendAccountStore((state) => state.setAccount);
  const [isAddAccountOpen, setIsAddAccountOpen] = useState(false);

  return (
    <>
      <ScrollArea className="flex max-h-[528px] w-full flex-col px-5 pb-5">
        {!isLoading &&
          data?.filter((item) => item.status === 'ACTIVE')
            .map((item) => (
              <CurrencyAccountItem
                item={item}
                onClick={() => {
                  setAccount(item);
                  onSelect();
                }}
                className="last:mb-3"
                isSelected={account?.id === item.id}
                key={item.id}
              />
            ))}
        <div className="flex w-full items-center justify-center gap-1">
          <Typography variant="13-r" color="text-base-100">
            Currency not listed?
          </Typography>
          <Button
            variant="clean"
            onClick={() => {
              setIsAddAccountOpen(true);
            }}
          >
            <Typography variant="13-r" color="brand-500">
              Request new currency
            </Typography>
          </Button>
        </div>
      </ScrollArea>
      <AddAccount
        open={isAddAccountOpen}
        onOpenChange={setIsAddAccountOpen}
        onConfirmAdding={() => {
          onClose();
        }}
      >
        <></>
      </AddAccount>
    </>
  );
};
